module.exports = __webpack_public_path__ + "media/images/guide-thumb-5-231fc20bdf57529a6b57574882a2ab33.png";